import toast from '@/plugins/toast'
import app from '@/main.js'

import { CLEAR_ERRORS, RECORD_ERRORS, SET_LOADING, CLEAR_AUTH_INFO } from '@/store/mutation-types'

export const requestInterceptor = (config) => {

    //console.log(config);

    if (config.url.split('/')[1] !== 'get-station') {
        app.$Progress.start();
    }

    return config;
}


export const responseSuccess = (response) => {

    // app.$store.commit(SET_LOADING, false)

    app.$Progress.finish();
    app.$store.commit(CLEAR_ERRORS)

    if (response.status == 201) {
        toast.success(response.data.message);
    }

    return response;
}

export const responseError = (error) => {

    app.$store.commit(SET_LOADING, false)
    app.$Progress.fail();

    switch (error.response.status) {
        case 422:
            app.$store.commit(RECORD_ERRORS, error.response.data.errors)
            break;
        case 401:
            let err = [];
            // err['unauthorized'] = [error.response.data.message]
            err['unauthorized'] = ['Session expired']

            app.$store.commit(RECORD_ERRORS, err)
            app.$store.commit(CLEAR_AUTH_INFO)
            app.$router.go('/login', () => {})
            break;
            case 402:

            swal.fire({
                text: `You have already created a radio. Please login to start streaming`,
                confirmButtonText: "ok",
                confirmButtonColor: "#e64942",
                showCancelButton: false,
                focusCancel: true,
              }).then((result) => {
                  window.location.href = process.env.VUE_APP_FRONTEND_BASE_URL + '/login'
  
              });
            
            break;
        default:
            //todo create logic for code 500 n display something wennt wrong
            toast.error(error.response.data.message);
            break;
    }


    return Promise.reject(error)

}